import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/engineering/$slug")({
  loader: ({ params }) => {
    throw redirect({ to: "/labs/research/$slug", params: { slug: params.slug } });
  },
  component: () => null,
});

